import React from 'react';

const LastLocation = () => (
  <div className='container-fluid'>
    Page Under Construction
  </div>
);

export default LastLocation;
